module.exports = __webpack_public_path__ + "img/friend.b7b35cb3.png";